"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo } from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { AuthContext } from "@/components/auth/Auth";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { WaveSmallLeaderboardDrop } from "./WaveSmallLeaderboardDrop";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveSmallLeaderboardProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveSmallLeaderboard: React.FC<WaveSmallLeaderboardProps> = t0 => {
  const $ = _c(21);
  const {
    wave,
    onDropClick
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const t1 = connectedProfile?.handle ?? null;
  let t2;
  if ($[0] !== t1 || $[1] !== wave.id) {
    t2 = {
      waveId: wave.id,
      connectedProfileHandle: t1
    };
    $[0] = t1;
    $[1] = wave.id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t2);
  const memoizedDrops = drops;
  let t3;
  if ($[3] !== fetchNextPage || $[4] !== hasNextPage || $[5] !== isFetching || $[6] !== isFetchingNextPage) {
    t3 = () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[3] = fetchNextPage;
    $[4] = hasNextPage;
    $[5] = isFetching;
    $[6] = isFetchingNextPage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const intersectionElementRef = useIntersectionObserver(t3);
  let t4;
  if ($[8] !== isFetching || $[9] !== memoizedDrops || $[10] !== onDropClick || $[11] !== wave) {
    t4 = memoizedDrops.length === 0 && !isFetching ? <div className="tw-text-iron-400 tw-text-center tw-py-4">No drops have been made yet in this wave</div> : <ul className="tw-space-y-3 tw-pl-0">{memoizedDrops.map(drop => <WaveSmallLeaderboardDrop drop={drop} wave={wave} key={drop.id} onDropClick={onDropClick} />)}</ul>;
    $[8] = isFetching;
    $[9] = memoizedDrops;
    $[10] = onDropClick;
    $[11] = wave;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isFetchingNextPage) {
    t5 = isFetchingNextPage && <div className="tw-w-full tw-h-0.5 tw-bg-iron-800 tw-overflow-hidden"><div className="tw-w-full tw-h-full tw-bg-indigo-400 tw-animate-loading-bar" /></div>;
    $[13] = isFetchingNextPage;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== intersectionElementRef) {
    t6 = <div ref={intersectionElementRef} />;
    $[15] = intersectionElementRef;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="tw-p-4"><div className="tw-flex tw-flex-col">{t4}{t5}{t6}</div></div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};